import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {FormArray} from "@angular/forms";
import {ItineraryService} from "../../../core/services/itinerary.service";
import {ItineraryTemplatesService} from "../../../core/services/itinerary-templates.service";
import {NzModalRef} from "ng-zorro-antd/modal";
import {SETTINGS} from "../../../core/config/common.settings";
import {NzMessageService} from "ng-zorro-antd/message";
import {LoadingService} from "../../../core/services/loading.service";
import {displayTitle} from "../../../core/ult-functions/common";
import { withItineraryLockSession } from "../../../core/ult-functions/itinerary-tab-session";

@Component({
  selector: 'app-experiences-drag',
  templateUrl: './experiences-drag.component.html',
  styleUrls: ['./experiences-drag.component.scss'],
})
export class ExperiencesDragComponent implements OnInit {
  @Input() dayIndex: any;
  @Input() experiences: any;
  @Input() lang: any;
  @Input() id: any;
  @Input() itineraryMode: 'itinerary' | 'template' = 'itinerary';
  @Input() sessionId?: string;
  draggedExperiencesIndex: number | null = null;
  isButtonLoading = false;
  protected readonly displayTitle = displayTitle;

  get activeService(): ItineraryService | ItineraryTemplatesService {
    return this.itineraryMode === 'template' ? this.itineraryTemplatesService : this.itineraryService;
  }

  constructor(
    private modal: NzModalRef,
    private nzMessageService: NzMessageService,
    private loading: LoadingService,
    private itineraryService: ItineraryService,
    private itineraryTemplatesService: ItineraryTemplatesService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {}

  handleCancel(): void {
    this.modal.close({ message: "error" });
  }

  async saveRerder(): Promise<void> {
    this.loading.start();
    this.isButtonLoading = true;
    try {
      await this.activeService.updateItineraryLockState(withItineraryLockSession({
        _id: this.id,
        experiences: this.experiences,
      }, this.sessionId!));
      this.nzMessageService.success(this.translocoService.translate("itineraries.experiencesDrag.messages.reordered"));
      this.modal.close({ message: "success" });
    } catch (error: any) {
      const msg =
        error?.error?.message || error?.message?.message || error?.message || this.translocoService.translate("itineraries.experiencesDrag.messages.somethingWentWrong");
      this.nzMessageService.error(msg);
      this.modal.close({ message: "error" });
    } finally {
      this.isButtonLoading = false;
      this.loading.stop();
    }
  }

  onExperiencesDragStart(event: any, index: number): void {
    this.draggedExperiencesIndex = index;
  }

  onExperiencesDragOver(event: any): void {
    event.preventDefault();
  }

  onExperiencesDrop(event: any, targetIndex: number): void {
    event.preventDefault();

    const draggedIndex = this.draggedExperiencesIndex;
    if (draggedIndex === null) {
      return;
    }

    // Call a method to reorder the form array
    this.reorderExperiencesArray(draggedIndex, targetIndex);
    this.draggedExperiencesIndex = null;
  }

  reorderExperiencesArray(fromIndex: number, toIndex: number): void {
    const experiencePerDay = this.experiences[this.dayIndex].experiencesPerDay;

    if (fromIndex !== toIndex && experiencePerDay) {
      const [draggedItem] = experiencePerDay.splice(fromIndex, 1);
      experiencePerDay.splice(toIndex, 0, draggedItem);
      this.experiences[this.dayIndex].experiencesPerDay = experiencePerDay;
    }
  }
}
